export const RecurringInterval = {
    DAILY: 'DAILY',
    WEEKLY: 'WEEKLY',
    BI_WEEKLY: 'BI_WEEKLY',
    DAYS_OF_WEEK: 'DAYS_OF_WEEK',
    DAYS_OF_MONTH: 'DAYS_OF_MONTH',
    SEMI_MONTHLY: 'SEMI_MONTHLY',
    MONTHLY: 'MONTHLY',
    QUARTERLY: 'QUARTERLY',
    SEMI_ANNUALLY: 'SEMI_ANNUALLY',
    YEARLY: 'YEARLY'
};

export const Currency = {
    USD: 'USD',
    CAD: 'CAD',
    CNY: 'CNY'
};

export const TransactionType = {
    DEBIT: 'Debit',
    CREDIT: 'Credit'
};

export const PaymentMethod = {
    CASH: 'CASH',
    CREDIT_CARD: 'CREDIT_CARD'
};

export const ScheduledTransactionType = {
    RECURRING: 'RECURRING',
    ONE_TIME: 'ONE_TIME'
};

export const AccountType = {
    CHECKING: 'CHECKING',
    SAVINGS: 'SAVINGS',
    INVESTMENT: 'INVESTMENT'
};

export const ScheduledTransactionAction = {
    INFLOW: 'INFLOW',
    OUTFLOW: 'OUTFLOW',
    MOVE: 'MOVE'
};

export const CashFlowRange = Object.freeze({
    ONE_MONTH: '1M',
    THREE_MONTHS: '3M',
    SIX_MONTHS: '6M',
    ONE_YEAR: '1Y',
});

export const BudgetFrequency = {
    MONTHLY: 'MONTHLY',
    SPECIFIC_MONTHS: 'SPECIFIC_MONTHS'
};

export const AdminSection = {
    OVERVIEW: 'OVERVIEW',
    QUOTA: 'QUOTA',
    SCRIPTS: 'SCRIPTS',
    LOGS: 'LOGS',
    IMPORT: 'IMPORT',
    EXPORT: 'EXPORT',
    DEMO_DATA: 'DEMO_DATA'
};

export const InvestmentAccountCategory = {
    TFSA: 'TFSA',
    RRSP: 'RRSP',
    FHSA: 'FHSA',
    RESP: 'RESP',
    NON_REGISTERED: 'NON_REGISTERED',
    MARGIN_CA: 'MARGIN_CA',
    TAXABLE_US: 'TAXABLE_US',
    F401K: '401K',
    IRA_TRADITIONAL: 'IRA_TRADITIONAL',
    IRA_ROTH: 'IRA_ROTH',
    MARGIN_US: 'MARGIN_US'
};

export const INVESTMENT_ACCOUNT_CATEGORY_LABELS = {
    TFSA: 'TFSA',
    RRSP: 'RRSP',
    FHSA: 'FHSA (First Home)',
    RESP: 'RESP (Education)',
    NON_REGISTERED: 'Non-Registered',
    MARGIN_CA: 'Margin (CAD)',
    TAXABLE_US: 'Taxable (US)',
    '401K': '401(k)',
    F401K: '401(k)',
    IRA_TRADITIONAL: 'Traditional IRA',
    IRA_ROTH: 'Roth IRA',
    MARGIN_US: 'Margin (US)'
};

export const CAD_INVESTMENT_ACCOUNT_CATEGORIES = [
    InvestmentAccountCategory.TFSA,
    InvestmentAccountCategory.RRSP,
    InvestmentAccountCategory.FHSA,
    InvestmentAccountCategory.RESP,
    InvestmentAccountCategory.NON_REGISTERED,
    InvestmentAccountCategory.MARGIN_CA,
];

export const USD_INVESTMENT_ACCOUNT_CATEGORIES = [
    InvestmentAccountCategory.F401K,
    InvestmentAccountCategory.IRA_TRADITIONAL,
    InvestmentAccountCategory.IRA_ROTH,
    InvestmentAccountCategory.TAXABLE_US,
    InvestmentAccountCategory.MARGIN_US,
];

export const formatInvestmentAccountLabel = (acc) => {
    if (!acc) return '';
    const name = (acc.name || '').trim();
    if (!name) return 'Investment Account';
    const ccy = (acc.currency || '').trim();
    if (ccy && !name.toUpperCase().includes(ccy.toUpperCase())) {
        return `${name} (${ccy})`;
    }
    return name;
};

export const PortfolioPeriod = {
    ONE_WEEK: '1W',
    ONE_MONTH: '1M',
    THREE_MONTHS: '3M',
    SIX_MONTHS: '6M',
    YTD: 'YTD',
    ONE_YEAR: '1Y',
    THREE_YEARS: '3Y',
    FIVE_YEARS: '5Y',
    ALL: 'ALL'
};

export const BenchmarkIndex = {
    SP500: 'SP500',
    TSX: 'TSX'
};

export const Timezone = {
    AMERICA_NEW_YORK: 'America/New_York',
    AMERICA_CHICAGO: 'America/Chicago',
    AMERICA_DENVER: 'America/Denver',
    AMERICA_LOS_ANGELES: 'America/Los_Angeles',
    AMERICA_ANCHORAGE: 'America/Anchorage',
    AMERICA_HONOLULU: 'America/Honolulu',
    AMERICA_TORONTO: 'America/Toronto',
    AMERICA_VANCOUVER: 'America/Vancouver',
    AMERICA_EDMONTON: 'America/Edmonton',
    AMERICA_WINNIPEG: 'America/Winnipeg',
    AMERICA_HALIFAX: 'America/Halifax',
    AMERICA_ST_JOHNS: 'America/St_Johns',
    UTC: 'UTC',
    EUROPE_LONDON: 'Europe/London',
    EUROPE_PARIS: 'Europe/Paris',
    EUROPE_BERLIN: 'Europe/Berlin',
    EUROPE_ROME: 'Europe/Rome',
    EUROPE_MADRID: 'Europe/Madrid',
    EUROPE_AMSTERDAM: 'Europe/Amsterdam',
    EUROPE_ZURICH: 'Europe/Zurich',
    ASIA_SHANGHAI: 'Asia/Shanghai',
    ASIA_HONG_KONG: 'Asia/Hong_Kong',
    ASIA_TAIPEI: 'Asia/Taipei',
    ASIA_TOKYO: 'Asia/Tokyo',
    ASIA_SEOUL: 'Asia/Seoul',
    ASIA_SINGAPORE: 'Asia/Singapore',
    ASIA_BANGKOK: 'Asia/Bangkok',
    ASIA_KOLKATA: 'Asia/Kolkata',
    ASIA_DUBAI: 'Asia/Dubai',
    AUSTRALIA_SYDNEY: 'Australia/Sydney',
    AUSTRALIA_MELBOURNE: 'Australia/Melbourne',
    PACIFIC_AUCKLAND: 'Pacific/Auckland'
};

export const TIMEZONE_OPTIONS = [
    { value: 'America/New_York', label: 'Eastern Time - US (New York)' },
    { value: 'America/Toronto', label: 'Eastern Time - Canada (Toronto)' },
    { value: 'America/Chicago', label: 'Central Time - US (Chicago)' },
    { value: 'America/Winnipeg', label: 'Central Time - Canada (Winnipeg)' },
    { value: 'America/Denver', label: 'Mountain Time - US (Denver)' },
    { value: 'America/Edmonton', label: 'Mountain Time - Canada (Edmonton)' },
    { value: 'America/Los_Angeles', label: 'Pacific Time - US (Los Angeles)' },
    { value: 'America/Vancouver', label: 'Pacific Time - Canada (Vancouver)' },
    { value: 'America/Anchorage', label: 'Alaska Time (Anchorage)' },
    { value: 'America/Honolulu', label: 'Hawaii Time (Honolulu)' },
    { value: 'America/Halifax', label: 'Atlantic Time (Halifax)' },
    { value: 'America/St_Johns', label: "Newfoundland Time (St. John's)" },
    { value: 'UTC', label: 'UTC (Coordinated Universal Time)' },
    { value: 'Europe/London', label: 'London, Dublin (GMT / BST)' },
    { value: 'Europe/Paris', label: 'Paris, Brussels (CET / CEST)' },
    { value: 'Europe/Berlin', label: 'Berlin, Frankfurt (CET / CEST)' },
    { value: 'Europe/Rome', label: 'Rome (CET / CEST)' },
    { value: 'Europe/Madrid', label: 'Madrid (CET / CEST)' },
    { value: 'Europe/Amsterdam', label: 'Amsterdam (CET / CEST)' },
    { value: 'Europe/Zurich', label: 'Zurich (CET / CEST)' },
    { value: 'Asia/Dubai', label: 'Dubai (GST)' },
    { value: 'Asia/Kolkata', label: 'India Standard Time (Kolkata)' },
    { value: 'Asia/Bangkok', label: 'Bangkok, Jakarta (ICT)' },
    { value: 'Asia/Singapore', label: 'Singapore (SGT)' },
    { value: 'Asia/Hong_Kong', label: 'Hong Kong (HKT)' },
    { value: 'Asia/Shanghai', label: 'China Standard Time (Beijing, Shanghai)' },
    { value: 'Asia/Taipei', label: 'Taipei (CST)' },
    { value: 'Asia/Tokyo', label: 'Tokyo (JST)' },
    { value: 'Asia/Seoul', label: 'Seoul (KST)' },
    { value: 'Australia/Sydney', label: 'Sydney, Canberra (AEST / AEDT)' },
    { value: 'Australia/Melbourne', label: 'Melbourne (AEST / AEDT)' },
    { value: 'Pacific/Auckland', label: 'Auckland, Wellington (NZST / NZDT)' }
];

export const Language = {
    EN: 'en',
    FR: 'fr',
    ZH_CN: 'zh-CN',
    ZH_TW: 'zh-TW',
    ES: 'es'
};

export const getLanguageOptions = (currency) => [
    { value: Language.EN, label: 'English', nativeLabel: 'English', flag: (currency || '').toUpperCase() === Currency.CAD ? '🇨🇦' : '🇺🇸' },
    { value: Language.FR, label: 'French', nativeLabel: 'Français', flag: '🇫🇷' },
    { value: Language.ZH_CN, label: 'Simplified Chinese', nativeLabel: '简体中文', flag: '🇨🇳' },
    { value: Language.ZH_TW, label: 'Traditional Chinese', nativeLabel: '繁體中文', flag: '🇹🇼' },
    { value: Language.ES, label: 'Spanish', nativeLabel: 'Español', flag: '🇪🇸' }
];

export const LANGUAGE_OPTIONS = getLanguageOptions(Currency.USD);

export const AnimationTiming = Object.freeze({
    RECORD_REMOVE_MS: 300,
    DIFF_EXIT_MS: 350,
});

export const AdvisorChatRole = Object.freeze({
    USER: 'USER',
    ASSISTANT: 'ASSISTANT',
});

export const AdvisorChatMessageStatus = Object.freeze({
    COMPLETE: 'COMPLETE',
    ERROR: 'ERROR',
});

export const AdvisorChatEvent = Object.freeze({
    SESSION: 'SESSION',
    STATUS: 'STATUS',
    DELTA: 'DELTA',
    DONE: 'DONE',
    ERROR: 'ERROR',
});

export const AdvisorChartType = Object.freeze({
    BAR: 'bar',
    LINE: 'line',
    PIE: 'pie',
});

export const ServiceTier = Object.freeze({
    FREE: 'FREE',
    PRO: 'PRO',
    ADMIN: 'ADMIN',
});

export const UserStatus = Object.freeze({
    ACTIVE: 'ACTIVE',
    SUSPENDED: 'SUSPENDED',
    DEACTIVATED: 'DEACTIVATED',
});

export const AdminActionType = Object.freeze({
    DELETE_USER: 'DELETE_USER',
    UPDATE_TIER: 'UPDATE_TIER',
    UPDATE_STATUS: 'UPDATE_STATUS',
    RESET_USAGE: 'RESET_USAGE',
    SET_USAGE: 'SET_USAGE',
    RESET_2FA: 'RESET_2FA',
    REVOKE_SESSIONS: 'REVOKE_SESSIONS',
});

export const TokenPurpose = Object.freeze({
    ACCESS: 'access',
    TWO_FACTOR: '2fa',
});

